import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import {
    getActivityDiaryCalendarApi,
    getActivityDiaryDictTreeApi,
    getActivityDiaryByDateApi,
    getActivityDiaryByIdApi,
    getActivitiesDataApi,
    postActivityDiaryCommentApi,
    putActivityDiaryCommentApi,
    postActivitiesDataApi,
} from 'api'
import { BoundarySlice } from 'redux/reducers'

const initialState = {
    calendarInfo: null, // 被点击的日历信息
    calendarData: null, // 日历上当前范围内显示的总结填写信息
    dictData: null, // 数据字典
    listData: null, // 回显数据
    locationName: '', // location 名称
    locationId: '', // location id
    save: false,
    id: '',
}

/* 获取日历上的数据 */
export const getActivityDiaryCalendarAction = createAsyncThunk(
    'ActivityDiarySlice/getActivityDiaryCalendarAction',
    async (params, thunkAPI) => {
        try {
            const { data } = await getActivityDiaryCalendarApi(params)
            return data.data
        } catch (error) {
            thunkAPI.dispatch(BoundarySlice.actions.addError(error))
        }
    }
)

/* 获取数据字典 */
export const getActivityDiaryDictDataAction = createAsyncThunk(
    'ActivityDiarySlice/getActivityDiaryDictDataAction',
    async (dictType, thunkAPI) => {
        const activityTypeDataDict = getActivityDiaryDictTreeApi(dictType[0])
        return Promise.all([activityTypeDataDict])
            .then(dictData => dictData)
            .catch(error => thunkAPI.dispatch(BoundarySlice.actions.addError(error)))
    }
)

/* 通过日期获取 id */
export const getActivityDiaryByDateAction = createAsyncThunk(
    'ActivityDiarySlice/getActivityDiaryByDateAction',
    async (listDataParams, thunkAPI) => {
        try {
            const commentData = await getActivityDiaryByDateApi(listDataParams) // 通过日期查询 id
            return commentData?.data?.data?.id
        } catch (error) {
            thunkAPI.dispatch(BoundarySlice.actions.addError(error))
        }
    }
)

/* 获取数据 */
export const getActivityDiaryDataAction = createAsyncThunk(
    'ActivityDiarySlice/getActivityDiaryDataAction',
    async (id, thunkAPI) => {
        const commentData = getActivityDiaryByIdApi(id) // 通过 id 查询
        const activitiesData = getActivitiesDataApi(id)
        return Promise.all([commentData, activitiesData])
            .then(listData => listData)
            .catch(error => thunkAPI.dispatch(BoundarySlice.actions.addError(error)))
    }
)

/* 保存数据 */
export const postActivityDiaryDataAction = createAsyncThunk(
    'ActivityDiarySlice/postActivityDiaryDataAction',
    async ({ id, commentParams, activitiesParams }, { dispatch }) => {
        let vid
        try {
            if (!id) {
                const commentData = await postActivityDiaryCommentApi(commentParams) // 新增
                vid = commentData.data.data.id
                await postActivitiesDataApi(activitiesParams, vid)
                dispatch(ActivityDiarySlice.actions.addId(vid))
                return { isTrue: true, id: vid } // 已保存状态
            } else {
                vid = id
                await putActivityDiaryCommentApi(commentParams, id) // 修改
                await postActivitiesDataApi(activitiesParams, id)
                return { isTrue: true, id } // 已保存状态
            }
        } catch (error) {
            dispatch(ActivityDiarySlice.actions.addId(vid)) // 失败时，保存 id
            dispatch(BoundarySlice.actions.addError(error))
        }
    }
)

export const ActivityDiarySlice = createSlice({
    name: 'ActivityDiarySlice',
    initialState,
    reducers: {
        /* 日历点击信息 */
        addCalendarInfo: (state, action) => {
            state.calendarInfo = action.payload
        },
        /* 清空日历与详情页信息 */
        clearListData: state => {
            state.listData = null
            state.calendarData = null
            state.save = false
            state.id = ''
        },
        /* 当前日历主 id */
        addId: (state, action) => {
            state.id = action.payload
        },
        /* location 名称 */
        addLocationName: (state, action) => {
            state.locationName = action.payload
        },
        /* location id */
        addLocationId: (state, action) => {
            state.locationId = action.payload
        },
    },
    extraReducers: {
        /* 获取日历上的数据 */
        [getActivityDiaryCalendarAction.fulfilled.type]: (state, action) => {
            state.calendarData = action.payload
        },

        /* 处理数据字典 */
        [getActivityDiaryDictDataAction.fulfilled.type]: (state, action) => {
            state.dictData = action.payload
        },

        /* 提交总结数据 */
        [postActivityDiaryDataAction.fulfilled.type]: (state, action) => {
            state.save = action.payload
        },

        /* 获取回显数据 */
        [getActivityDiaryDataAction.fulfilled.type]: (state, action) => {
            state.listData = action.payload
        },

        /* 通过日期，获取 id */
        [getActivityDiaryByDateAction.fulfilled.type]: (state, action) => {
            state.id = action.payload
        },
    },
})
